module.exports = __webpack_public_path__ + "img/Coyote-Ridge.1f7c0ca2.jpeg";